import { Injectable } from '@angular/core';
import { JwtHelper } from './jwt-helper';
import { Observable ,  BehaviorSubject } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class AuthenticationTokenService {
    constructor() { }

    jwtHelper: JwtHelper = new JwtHelper();
    refreshTokenIdentifier = 'refresh_token';

    private currentRefreshToken: string;
    private currentAccessToken: string = null;
    private waitForAccessTokenSubject = new BehaviorSubject<string>(this.currentAccessToken);
    public waitForAccessTokenObservable = this.waitForAccessTokenSubject.asObservable();

    // Access token

    public waitForAccessToken(): Observable<string> {
        return this.waitForAccessTokenObservable;
    }

    public setAccessToken(token: string) {
        this.currentAccessToken = token;
        this.waitForAccessTokenSubject.next(this.currentAccessToken);
    }

    public getAccessToken(): string {
        return this.currentAccessToken;
    }

    public getAccessTokenData(): any {
        return this.jwtHelper.decodeToken(this.getAccessToken());
    }

    public removeAccessToken() {
        this.currentAccessToken = null;
    }

    public getAccessTokenExpirationDate(): Date {
        return this.jwtHelper.getTokenExpirationDate(this.getAccessToken());
    }

    public hasAccessToken(): boolean {
        return !!this.getAccessToken();
    }

    public hasValidAccessToken(): boolean {
        return !!this.getAccessToken() && !this.jwtHelper.isTokenExpired(this.getAccessToken());
    }

    // Refresh token

    public hasRefreshToken(): boolean {
        return !!this.getRefreshToken();
    }

    public setRefreshToken(token: string, rememberUser: boolean) {
        this.removeRefreshToken(); // Make sure there is no leftover...
        if (rememberUser) {
            localStorage.setItem(this.refreshTokenIdentifier, token);
        }
        else {
            this.currentRefreshToken = token;
        }
    }

    public getRefreshToken(): string {
        return this.currentRefreshToken || localStorage.getItem(this.refreshTokenIdentifier);
    }

    public removeRefreshToken() {
        this.currentRefreshToken = null;
        localStorage.removeItem(this.refreshTokenIdentifier);
    }
}
